import { render, staticRenderFns } from "./south-molton-triangle.vue?vue&type=template&id=646c0c06&"
import script from "./south-molton-triangle.vue?vue&type=script&lang=js&"
export * from "./south-molton-triangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports